import { Box, Skeleton } from '@mui/material'
import React from 'react'

const CardSkeleton = () => {
  return (
    <Box mb={2}>
        {Array.from({ length: 5 }).map((_, index) => (
            <Box key={index} mb={2}>
              <Skeleton variant='rectangular' width='100%' height={80} sx={{borderRadius: 2}} />
            </Box>
        ))}
    </Box>
  )
}

export default CardSkeleton